import clsx from "clsx";
import React from "react";

interface ISwitchProps {
  value?: boolean;
  onChange?: (newValue: boolean) => void;
  className?: string;
  isGrayBackground?: boolean;
}

const Switch = ({
  value,
  onChange,
  className,
  isGrayBackground,
}: ISwitchProps) => {
  return (
    <button
      type='button'
      onClick={() => {
        onChange?.(!value)
      }}
      className={clsx(
        'relative inline-flex items-center h-5 rounded-full w-9', 
        isGrayBackground ? 'bg-grayBlue' : 'bg-almostBlackBlue', 
        className,
      )}
    >
      <span
        className={clsx(
          'mb-[0.15625rem] inline-block w-3 h-3 transform bg-appGreen rounded-full transition ease-in-out duration-200', 
          value ? "translate-x-5" : "translate-x-1"
        )}
      />
      l
    </button>
  );
};

export default Switch;
